import { render, staticRenderFns } from "./stop4.vue?vue&type=template&id=1bf8a822&scoped=true"
import script from "./stop4.vue?vue&type=script&lang=js"
export * from "./stop4.vue?vue&type=script&lang=js"
import style0 from "./stop4.vue?vue&type=style&index=0&id=1bf8a822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8a822",
  null
  
)

export default component.exports